/**
 * Authenticated shell: sidebar, navbar, help chat, and mode provider.
 */

import * as React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useLayoutStore } from '@/stores/layoutStore';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { HelpAssistantChat } from '@/components/help/HelpAssistantChat';
import { ModeProvider } from '@/contexts/ModeContext';

/** Authenticated app chrome: sidebar, navbar, scroll-resetting main, and help chat. */
export const RootLayout: React.FC = () => {
  const { sidebarWidth } = useLayoutStore();
  const location = useLocation();
  const mainRef = React.useRef<HTMLElement>(null);

  /** Reset main scroll when the route changes so the new page starts at the top. */
  React.useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <ModeProvider>
      <div className="flex h-full min-h-0 overflow-hidden">
        <Sidebar />

        <div
          className="flex min-h-0 flex-1 flex-col overflow-hidden transition-all duration-300"
          style={
            {
              '--sidebar-width': `${sidebarWidth}px`,
              marginLeft: `${sidebarWidth}px`,
            } as React.CSSProperties
          }
        >
          <Navbar />

          <main ref={mainRef} className="min-h-0 flex-1 overflow-y-auto overscroll-none p-6">
            <Outlet />
          </main>
        </div>

        <HelpAssistantChat />
      </div>
    </ModeProvider>
  );
};
